import React, { Component } from 'react';

import './MediaObject.scss';

class MediaObject extends Component {
  /* eslint-disable jsx-a11y/alt-text */
  static Image = props => <div className="media-object__image"><img { ...props } /></div>

  static Content = ({ children, ...rest }) => <div className="media-object__content" { ...rest }>{children}</div>

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const { children } = this.props;

    return (
      <div className="media-object">
        {children}
      </div>
    );
  }
}

export default MediaObject;
